import React from 'react';

export type TrainerActionButtonVariant =
  | 'primary'
  | 'ghost'
  | 'dock-primary'
  | 'dock-ghost'
  | 'danger';

export type TrainerActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: TrainerActionButtonVariant;
  icon?: React.ReactNode;
};

const variantClass: Record<TrainerActionButtonVariant, string> = {
  primary: 'tr-btn-primary',
  ghost: 'tr-btn-ghost',
  'dock-primary': 'tr-btn-dock-primary',
  'dock-ghost': 'tr-btn-dock-ghost',
  danger: 'tr-btn-danger',
};

/** Thin presentational primary/ghost/dock/danger button — CSS-driven. */
export function TrainerActionButton({
  variant = 'primary',
  icon,
  className,
  children,
  type = 'button',
  ...rest
}: TrainerActionButtonProps) {
  const classes = [variantClass[variant], className].filter(Boolean).join(' ');
  return (
    <button type={type} className={classes} {...rest}>
      {icon}
      {children}
    </button>
  );
}
